module.exports = __webpack_public_path__ + "img/web2x_icon_dachangji2.1b04c561.png";